
import $ from "jquery"
import Clipboard from "clipboard"


interface Selector {
  scope:  string | HTMLElement | JQuery
  button: string | HTMLElement | JQuery
}
export interface InputSelector {
  scope:    string | HTMLElement | JQuery
  button?:  string | HTMLElement | JQuery
}
const default_selector = {
  scope: "body",
  button: ".js-listing-reference-copy",
}


class CopyBtn {
  protected selector: Selector
  protected $scope:   JQuery
  protected $el:      JQuery
  protected clip:     Clipboard | null

  constructor(selector: InputSelector){
    this.selector = Object.assign({}, default_selector, selector)
    this.$scope = $(this.selector.scope)

    if (this.$scope.length !== 1 ) {
      throw new Error("clipboard btn init with more than one element")
    }

    this.$el = this.$scope.find(this.selector.button)

    this.clip = new Clipboard(this.$el[0])
    this.bind_action()
    return this
  }

  protected bind_action(){
    if (this.clip != null) {
      this.clip.on("success", (e) => this.onSuccess(e))
    }
    // to Stop weird jumping to page top
    this.$el.on("click", (e) => e.preventDefault())
    return this
  }
  protected onSuccess(e: ClipboardJS.Event){
    e.clearSelection()
  }
}

export {
  CopyBtn,
}
